import React from 'react';

import { useTranslation } from 'react-i18next';

import config from '@app/config';

import { Item, Link, StyledList } from './FooterLinks.style';

const { privacyLink, supportLink, termsLink } = config;

export function FooterLinks() {
    const [translate] = useTranslation('connectWallet');

    return (
        <StyledList>
            <Item>
                <Link to={termsLink} target="_blank" rel="noopener noreferrer">
                    {translate('sheet-footer-link-terms')}
                </Link>
            </Item>
            <Item>
                <Link to={privacyLink} target="_blank" rel="noopener noreferrer">
                    {translate('sheet-footer-link-privacy')}
                </Link>
            </Item>
            <Item>
                <Link to={supportLink} target="_blank" rel="noopener noreferrer">
                    {translate('sheet-footer-link-help')}
                </Link>
            </Item>
        </StyledList>
    );
}
